import { render } from "./ScoreView.vue?vue&type=template&id=7bad4346"
import script from "./ScoreView.vue?vue&type=script&lang=js"
export * from "./ScoreView.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ScoreView.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__